// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"016672da","208":"b65676a8","293":"b6d3e563","516":"c5b61b86","917":"0728efa1","946":"dbe1f417"}[chunkId] + ".chunk.js";
};